import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { CKEditor4 } from "ckeditor4-angular/ckeditor";
import { Subscription } from 'rxjs';
import { HtmlTemplateService } from 'src/app/services/tempate/html-template.service';
import * as moment from 'moment';

@Component({
  selector: 'app-create-image-task',
  templateUrl: './create-image-task.component.html',
  styleUrls: ['./create-image-task.component.scss']
})
export class CreateImageTaskComponent implements OnInit {
  formGroup;
  sampleImage: any = []

  templeteHtml: any = "";
  submitted: boolean = false;

  selectedSingleImage: any = "";
  selectedWrongImage: any = ""
  selectedRightImage: any = ""
  elementId: any = "";
  test = true;

  rewardFixed: any = "";
  rewardWeekly: any = "";
  elementType: any = "";
  isUserwhitelisted : boolean = false;

  @Input() engagementId = "";

  @Output() engagementCreated: EventEmitter<boolean> = new EventEmitter;
  @Output() getEngagementId: EventEmitter<number> = new EventEmitter;
  @Output() getEngagementTypeId: EventEmitter<number> = new EventEmitter;
  @Output() whitelist_obj: EventEmitter<object> = new EventEmitter;
  editRes: any;
  templateType = "en"

  editorConfig = {
    toolbarGroups: [
      { name: "clipboard", groups: ["clipboard", "undo"] },
      { name: "editing", groups: ["find", "selection", "spellchecker"] },
      { name: "links" },
      { name: "insert" },
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
      { name: "styles" },
      { name: "colors" },
    ],
    skin: "kama",
    resize_enabled: false,
    removePlugins: "elementspath,save,magicline",
    extraPlugins: "divarea,smiley,justify,indentblock,colordialog",
    colorButton_foreStyle: {
      element: "font",
      attributes: { color: "#(color)" },
    },
    height: 188,
    versionCheck : false,
    removeDialogTabs: "image:advanced;link:advanced",
    removeButtons: "Subscript,Superscript,Anchor,Source,Table",
    format_tags: "p;h1;h2;h3;pre;div",
  };

  engagementTypes: any = [];
  engagementElement: any = [];
  roleTypes:any = [];

  rewardText: any;
  rewardWeek: any;
  reward15Ddwy: any;
  rewardMonth: any;
  subscription: Subscription;
  rewardType: any;
  localData: any
  minDate: any;
  constructor(
    private ngWizardService: NgWizardService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private htmlTemplateService: HtmlTemplateService

  ) {
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0]; 
  }

  ngOnInit() {
    this.formDetails()
    this.getRoleTypes();
    this.getEngagementTypes();
    if(this.localData.is_edit == true){
      this.getEnagagementDataOnEdit()
      this.whitelist_obj.emit({wts_type : this.localData.whitelist_type ,zn_type : this.localData.zone_type})
    }
  }

  formDetails(data?, template?) {
    // if(data) this.getEngagementElement(data.engagement_type_id)
    this.formGroup = this.fb.group({
      title: new FormControl(data ? data.task_title : "", []),
      start_date: new FormControl(data ? data.start_date : "", [Validators.required]),
      end_date: new FormControl(data ? data.end_date : "", [Validators.required]),
      engagement_type: new FormControl(data ? data.engagement_type_id : "", [Validators.required]),
      element_type: new FormControl(data ? data.posm_element_config_id : "", []),
      engagement_name: new FormControl(data ? data.engagement_title : "", [Validators.required]),
      reward_type: new FormControl(data ? data.reward_type : "", [Validators.required]),
      reward_type_text: new FormControl(data ? data.points : "",),
      reward_week: new FormControl(data ? data.weekly_points : "",),
      reward_15_day: new FormControl(data ? data.half_month : "",),
      reward_month: new FormControl(data ? data.full_month : "",),
      audit_instruction_templete: new FormControl(data ? data.audit_criteria : "", [Validators.required]),
      whitelist_type : new FormControl(data?data.whitelist_type:"",[Validators.required]),
      zone_type : new FormControl({ value: data ? data.zone_type :"", disabled: this.isUserwhitelisted ? true : false},[]),
      role_type : new FormControl(data?data.role_type:"",[Validators.required]),

      //templete
      templete_type: new FormControl(template ? template.templete_type : "", [Validators.required]),
      templete_wrong_img: new FormControl(template ? template.templete_wrong_img : "", []),
      temple_right_img: new FormControl(template ? template.temple_right_img : "", []),
      single_image: new FormControl({value : template ? template.single_image : "" , disabled: this.isUserwhitelisted ? true : false}, []),
      image_insruction: new FormControl(template ? template.image_insruction : "", []),
      image_insruction_wrong: new FormControl(template ? template.image_insruction_wrong : "", []),
      image_insruction_right: new FormControl(template ? template.image_insruction_right : "", []),
      templete_insruction_one: new FormControl(template ? template.templete_insruction_one : "", []),
      templete_insruction_two: new FormControl(template ? template.templete_insruction_two : "", []),
      templete_insruction_three: new FormControl(template ? template.templete_insruction_three : "", []),
      templete_title: new FormControl(template ? template.templete_title : "", []),
      instruction: new FormControl("Instructions", []),
    });
    if (data) {
      this.getEngagementElement(data.engagement_type_id)
      this.getImageTemplete();
    }
  }

  get f() {
    return this.formGroup.controls;
  }

  rewardTypeChange(e) {
    console.log(e)
    if (e == 1) {
      this.formGroup.controls["reward_month"].setValidators(Validators.required);
      this.formGroup.controls["reward_type_text"].clearValidators();
      this.formGroup.controls["reward_type_text"].setErrors(null);
      this.formGroup.updateValueAndValidity();
    } else {
      this.formGroup.controls["reward_type_text"].setValidators(Validators.required);
      this.formGroup.controls["reward_month"].clearValidators();
      this.formGroup.controls["reward_month"].setErrors(null);
      this.formGroup.updateValueAndValidity();
    }
  }

  templateTypeChnage(e){
    if(e.target.value == 1){
      this.formGroup.controls["single_image"].setValidators(Validators.required)
      this.formGroup.controls["templete_wrong_img"].clearValidators();
      this.formGroup.controls["temple_right_img"].clearValidators();
      this.formGroup.controls["templete_wrong_img"].setErrors(null);
      this.formGroup.controls["temple_right_img"].setErrors(null);
      this.formGroup.updateValueAndValidity();
    }else{
      this.formGroup.controls["templete_wrong_img"].setValidators(Validators.required)
      this.formGroup.controls["temple_right_img"].setValidators(Validators.required)
      this.formGroup.controls["single_image"].clearValidators();
      this.formGroup.controls["single_image"].setErrors(null);
      this.formGroup.updateValueAndValidity();
    }
  }

  whitelistTypeChange(e){
    console.log(e);
    if(e.target.value == '2'){
      this.formGroup.get('zone_type').setValidators([Validators.required])
    }else{
      this.formGroup.controls["zone_type"].clearValidators();
      this.formGroup.controls["zone_type"].setErrors(null);
    }
  }

  getRoleTypes(){
    this.apiService.get(this.apiConfig.configGetRoles).subscribe((res)=>{
      this.roleTypes = res['data'].filter(item => item.id == 5)
      console.log(this.roleTypes);
    })
  }

  getEngagementTypes() {
    this.apiService.get(this.apiConfig.engagementTypes + `?engagement_page=1`).subscribe((res: any) => {
      console.log(res)
      this.engagementTypes = res.data.engagementtypes;
    })
  }

  getEngagementElement(e) {
    console.log(e)
    this.apiService.get(this.apiConfig.engagementElement + `?element_type=${e}`).subscribe((res: any) => {
      console.log(res)
      this.engagementElement = res.data.elements;
    })
  }

  getEnagagementDataOnEdit() {
    this.apiService.get(this.apiConfig.viewEngagementDetail + `?engagement_page=1&engagement_type_id=${this.localData.engagement_type_id}&portfolio_id=${this.localData.portfolio_id}&task_id=${this.localData.task_id}`).subscribe((res: any) => {
      console.log(res)
      this.isUserwhitelisted = res.data.engagement.is_whitelisted
      this.localData.isUserwhitelisted = this.isUserwhitelisted;
      localStorage.setItem(
        'engagementDetail',
         JSON.stringify(this.localData)
      );
      setTimeout(() => {
        let template = JSON.parse(res.data.engagement.template_instructions)
        this.getEngagementElement(res.data.engagement.engagement_type_id)
        console.log(template)
        if(this.isUserwhitelisted){
          this.formGroup.get('whitelist_type').disable()
          this.formGroup.get('role_type').disable()
          this.formGroup.get('templete_type').disable()
        }
        this.formDetails(res.data.engagement, template)
      }, 100);
    })
  }

  getEngagementImages(e) {
    this.apiService.get(this.apiConfig.getEngagementTemplateDetail + `?element_id=${e.target.value}`).subscribe((res: any) => {
      console.log(res)
      this.sampleImage = res.data.template_images

    })
  }

  getImageTemplete() {
    let point = this.f.reward_type.value == 1 ? "" : `${this.f.reward_type_text.value} points`
    if (this.f.engagement_type.value == 6 || this.f.engagement_type.value == 4 || this.f.engagement_type.value == 5) {
      if (this.f.templete_type.value == 1) {
        this.templeteHtml = this.htmlTemplateService.getSingleImageTemplate(this.formGroup.getRawValue(), point)
      } else {
        this.templeteHtml = this.htmlTemplateService.getDubbleImageTemplate(this.formGroup.getRawValue(), point)
      }
    } else if (this.f.engagement_type.value == 1) {
      if (this.f.templete_type.value == 1) {
        this.templeteHtml = this.htmlTemplateService.ChillerVisibitlitySinglelImage(this.formGroup.getRawValue(), point)
      } else {
        this.templeteHtml = this.htmlTemplateService.ChillerVisibitlityDoubbelImage(this.formGroup.getRawValue(), point)
      }
    } else if (this.f.engagement_type.value == 2 || this.f.engagement_type.value == 3) {
      if (this.f.templete_type.value == 1) {
        this.templeteHtml = this.htmlTemplateService.posmSingleImage(this.formGroup.getRawValue(), point)
      } else {
        this.templeteHtml = this.htmlTemplateService.posmDubbleImage(this.formGroup.getRawValue(), point)
      }
    }
  }

  ImageUpload(event, type, lang_type) {
    let iamge_type = type == 'single' ? 3 : type == 'right' ? 1 : 2
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log(reader.result);
      let payload = {
        engagement_id: this.f.engagement_type.value,
        element_id: this.f.engagement_type.value,
        image_type: iamge_type,
        image: reader.result,
      }
      // console.log(payload)
      this.apiService.post(this.apiConfig.uploadInstructionImage, payload).subscribe((res: any) => {
        console.log(res)
        if (lang_type == 'en') {
          if (iamge_type == 1) {
            this.formGroup.controls["temple_right_img"].patchValue(res.body.data.image)
          } else if (iamge_type == 2) {
            this.formGroup.controls["templete_wrong_img"].patchValue(res.body.data.image)
          } else if (iamge_type == 3) {
            this.formGroup.controls["single_image"].patchValue(res.body.data.image)
          }
        }
      })
    };
  }

  selecteImage(img, type, language) {
    if (language == 1) {
      if (this.f.templete_type.value == 1) {
        this.formGroup.controls["single_image"].patchValue(img)
        this.selectedSingleImage = img;

      } else if (this.f.templete_type.value == 2 && type == "wrong") {
        this.formGroup.controls["templete_wrong_img"].patchValue(img)
        this.selectedWrongImage = img;

      } else if (this.f.templete_type.value == 2 && type == "right") {
        this.selectedRightImage = img;
        this.formGroup.controls["temple_right_img"].patchValue(img)
      }
    }
  }

  submit(form) {
    let value = form.getRawValue()
    console.log(value)
    this.submitted = true;
    console.log(this.formGroup)
    if (this.formGroup.invalid) {
      return this.toast.Warning('Select Required Feilds')
    }

    if(value.reward_type_text < 0){
      return this.toast.Warning('Points should not be less than zero')
    }

    let engagement_id = !this.engagementId ? "" : this.engagementId

    console.log(engagement_id);
    
    let payload = {
      task_title: value.title,
      portfolio_id: 1,
      engagement_id: value.engagement_type,
      engagement_title: value.engagement_name,
      start_date: moment(value.start_date).format("YYYY-MM-DD"),
      end_date: moment(value.end_date).format("YYYY-MM-DD"),
      reward_type: value.reward_type,
      week_points: value.reward_type == 1 ? value.reward_week : "",
      half_month_points: value.reward_type == 1 ? value.reward_15_day : "",
      full_month_points: value.reward_type == 1 ? value.reward_month : value.reward_type_text,
      element_id: value.element_type,
      audit_instructions: value.audit_instruction_templete,
      audit_template: this.templeteHtml,
      task_id: engagement_id,

      template_instructions: {
        templete_type: this.f.templete_type.value,
        single_image: this.f.single_image.value,
        templete_wrong_img: this.f.templete_wrong_img.value,
        temple_right_img: this.f.temple_right_img.value,
        image_insruction: this.f.image_insruction.value,
        templete_insruction_one: this.f.templete_insruction_one.value,
        templete_insruction_two: this.f.templete_insruction_two.value,
        templete_insruction_three: this.f.templete_insruction_three.value,
        templete_title: this.f.templete_title.value
      },

      isEdit: (this.localData.is_edit || this.engagementId != "") ? 1 : 0,
      whitelist_type:this.f.whitelist_type.value,
      zone_type : this.f.zone_type.value,
      role_type : this.f.role_type.value
    }
    console.log(payload)
    this.apiService.post(this.apiConfig.createImageEngagement, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success("Engagement created Successfully")
      this.engagementCreated.emit(true)
    
      this.localData.task_id = res.body.data.task_id,
      this.localData.sub_tasks_id = res.body.data.sub_tasks_id,
      this.localData.has_subtask = res.body.data.has_subtask,
      this.localData.engagement_type_id = res.body.data.engagement_type_id,
      this.localData.engagement_type = res.body.data.engagement_type,
      this.localData.portfolio_id = value.portfolio,
      this.localData.points_calculation_flag = 0,
      this.localData.whitelist_type =this.f.whitelist_type.value,
      this.localData.zone_type  = this.f.zone_type.value,
      this.localData.role_type  = this.f.role_type.value,
      
      this.engagementId = res.body.data.task_id
      localStorage.setItem("engagementDetail", JSON.stringify(this.localData))
      this.whitelist_obj.emit({wts_type : this.f.whitelist_type.value ,zn_type : this.f.zone_type.value})
      this.getEngagementId.emit(res.body.data.task_id);
      this.getEngagementTypeId.emit(res.body.data.engagement_type_id)
    }, err => {
      this.toast.Error(err.body.data)
    })

  }


}
